export default "__VITE_ASSET__Boc_gYv___"